import { useEffect } from 'react';

const BASE = 'Spark Boards';

/**
 * Set the browser tab title to "Spark Boards – {name}" for the current board / whiteboard / item, and
 * restore the bare base title when the page unmounts (so navigating back to an index clears the suffix).
 * Pass a falsy name to show just the base.
 */
export function useDocumentTitle(name?: string | null) {
  useEffect(() => {
    document.title = name ? `${BASE} – ${name}` : BASE;
    return () => {
      document.title = BASE;
    };
  }, [name]);
}
